module.exports = __webpack_public_path__ + "img/sos.b2abb457.png";